import React, { useEffect, useState } from "react";
import { useAppSelector, useAppDispatch } from "hooks/redux";

import {
  IPutTeeSheetSettings,
  PutFacilityTeeSheetSettings,
} from "api/rpc/2024-04/facilityAdmin/facility/settings";
import { StatusCode } from "api/protocols";

import { showError, showSuccess } from "redux/actions/ui";

import Page from "components/page/Page";
import Card from "components/card/Card";
import Toggle from "components/form/toggle/Toggle";
import FormLayout from "components/form/FormLayout";
import { useTranslation } from "react-i18next";
import { updateFacilityTeeSheetSettings } from "redux/actions/facility";

export default function FacilitySettings() {
  const dispatch = useAppDispatch();
  const { facilityStore } = useAppSelector(store => store);
  const [facilitySettings, setFacilitySettings] = useState<IPutTeeSheetSettings>(undefined);
  const { t } = useTranslation();

  useEffect(() => {
    if (facilityStore.teeSheetSettings) {
      setFacilitySettings(facilityStore.teeSheetSettings);
    }
  }, [facilityStore.teeSheetSettings]);

  async function saveSettings() {
    const settingsRes = await PutFacilityTeeSheetSettings(
      {
        ...facilitySettings,
      },
      true,
    );

    if (settingsRes.status !== StatusCode.OK) {
      dispatch(showError(t("Error updating facility settings")));
      return;
    }

    console.log('settings res', settingsRes);
    dispatch(showSuccess(t("Facility settings updated successfully")));
    void dispatch(updateFacilityTeeSheetSettings(settingsRes.data, true));
  }

  const primaryAction = {
    content: t("Save"),
    action: saveSettings,
  };

  console.log('facility settings', facilitySettings);
  return (
    <Page title={t("Facility Settings")} primaryAction={primaryAction}>
      <Card>
        <Card.Section>
          <FormLayout>
            <FormLayout.Group>
              <Toggle
                label={t("Force Note on Voided Orders")}
                onChange={e =>
                  setFacilitySettings(prevState => ({ ...prevState, orders_void_with_note: e.target.checked }))
                }
                checked={facilitySettings?.orders_void_with_note}
              />

              <Toggle
                label={t("Auto Select Generate Gift Card")}
                onChange={e =>
                  setFacilitySettings(prev => ({ ...prev, gift_cards_default_auto_generate_code: e.target.checked }))
                }
                checked={facilitySettings?.gift_cards_default_auto_generate_code}
              />

              <Toggle
                label="Show Receipt Signature"
                onChange={e => 
                  setFacilitySettings(prev => ({...prev, receipts_show_signature: e.target.checked}))
                }
                checked={facilitySettings?.receipts_show_signature}
              />
            </FormLayout.Group>
          </FormLayout>
        </Card.Section>
      </Card>
    </Page>
  );
}
